import { gql } from '@lcs/shared/api';

export const getDashboardTiles = gql`
   query GetDashboardTiles($filters: String) {
      dashboardTilesConnection(filters: $filters) {
         items {
            dashboardId
            dashboardTileId
            totalMillisecondsProcessed
            totalTimesProcessed
            tileViewMode
            tile {
               tileId
               name
               description
               typeId
               canEditRefreshTime
               isCustom
               reportParametersConnection {
                  items {
                     tileId
                     reportParameter {
                        reportParameterId
                        name
                        description
                     }
                     reportParameterId
                  }
               }
               tileViewModeBound {
                  heightLowerBound
                  heightUpperBound
                  widthLowerBound
                  widthUpperBound
               }
            }
            dashboardTileLayoutConfiguration {
               dashboardTileLayoutConfigurationId
               color
               height
               width
               refreshTimeSeconds
               maxHeight
               minHeight
               maxWidth
               minWidth
               name
               column
               row
            }
            dashboardTileParametersConnection {
               items {
                  parameterType
                  dashboardTileParameterId
                  dateRange {
                     relativeDate
                     relativeEndDate
                     relativeStartDate
                     startDate
                     endDate
                  }
                  entitiesToInclude {
                     all
                     entityIdsConnection {
                        items {
                           entityId
                           sortOrder
                        }
                     }
                     includeNull
                  }
                  valueBool
                  valueDateRangeParameterId
                  valueDateTime
                  valueEntitiesToIncludeId
                  valueNumeric
                  valueString
               }
            }
         }
      }
   }
`;
